import { Injectable } from '@angular/core';

declare let window: any;

const DEFAULT_HOST = 'www.tenthousandcoffees.com';

function _window(): any {
  return window ? window : { location: { host: DEFAULT_HOST } };
}

@Injectable({ providedIn: 'root' })
export class WindowRefService {
  get nativeWindow(): any {
    return _window();
  }
}
